import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconToast: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="toast, breakfest"><path d="M19.25 12.2608C20.5021 11.3651 21.25 10.2321 21.25 9C21.25 6.10051 17.1086 3.75 12 3.75C6.89137 3.75 2.75 6.10051 2.75 9C2.75 10.2321 3.49786 11.3651 4.75 12.2608V20.25H19.25V12.2608Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconToast;
